// extracted by mini-css-extract-plugin
export var text = "_a5-0";